import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
export interface GetReceiptURLRequest extends Partial<AxiosRequestConfig> {
  params: {
    bookingNumber: string;
  };
}
interface GetReceiptURLAPIResponseData {
  paymentReceiptUrl: string | null;
}
export interface GetReceiptURLAPIResponse extends AxiosResponse {
  data: GetReceiptURLAPIResponseData;
}
export function getReceiptURLAPI({
  params
}: GetReceiptURLRequest, axiosInstance: AxiosInstance) {
  return (axiosInstance({
    method: "get",
    url: `/booking/booking-receipt/${params.bookingNumber}`
  }) as Promise<GetReceiptURLAPIResponse>);
}